import { createAccessControl } from 'better-auth/plugins/access';
import {
  adminAc,
  defaultStatements,
  memberAc,
  ownerAc,
} from 'better-auth/plugins/organization/access';

export const customStatements = {
  ...defaultStatements,
  monitor: ['create', 'share', 'update', 'delete'],
  statusPage: ['create', 'share', 'update', 'delete'],
  incident: ['create', 'share', 'update', 'delete'],
  maintenanceWindow: ['create', 'share', 'update', 'delete'],
} as const;

export const customAccessControls = createAccessControl(customStatements);

export const owner = customAccessControls.newRole({
  ...ownerAc.statements,
  monitor: ['create', 'share', 'update', 'delete'],
  statusPage: ['create', 'share', 'update', 'delete'],
  incident: ['create', 'share', 'update', 'delete'],
  maintenanceWindow: ['create', 'share', 'update', 'delete'],
});

export const admin = customAccessControls.newRole({
  ...adminAc.statements,
  monitor: ['create', 'share', 'update', 'delete'],
  statusPage: ['create', 'share', 'update', 'delete'],
  incident: ['create', 'share', 'update', 'delete'],
  maintenanceWindow: ['create', 'share', 'update', 'delete'],
});

export const member = customAccessControls.newRole({
  ...memberAc.statements,
  monitor: ['create', 'share', 'update'],
  statusPage: ['share'],
  incident: ['create', 'share', 'update'],
  maintenanceWindow: ['create', 'share', 'update'],
});

export const roles = {
  owner,
  admin,
  member,
};
